<template>
  <div class="w-full">
    <div class="bg-grey-200 mb-6 h-px -mx-2 flex">
      <template v-if="input.heading">
        <h3 class="ml-4 px-4 leading-none text-base -mt-2 bg-white">
          {{ input.heading }}
        </h3>
      </template>
    </div>
    <small
      v-if="input.instructions"
      class="mb-4 -mt-2 mx-6 block italic"
      v-html="parseMarkdown(input.instructions)"
    />
  </div>
</template>

<script>
export default {
  name: "InputBreak",
  props: ["input"]
};
</script>
